import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class StorageService {
    constructor() {}

    static getItem(key: string): string {
        return localStorage.getItem(key) ? localStorage.getItem(key) : null;
    }

    static setItem(key: string, value: any): void {
        localStorage.setItem(key, JSON.stringify(value));
    }

    static removeItem(key: string): void {
        localStorage.removeItem(key);
    }

    static clearAll(): void {
        localStorage.clear();
    }
}
